<div class='container-fluid'>
  <div class='row'>
    <app-redirect class="main-content">
      <router-outlet></router-outlet>
    </app-redirect>
  </div>
</div>
